"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIsExperimentValid_1 = __importDefault(require("./getIsExperimentValid"));
const getIsExperimentLive_1 = __importDefault(require("./getIsExperimentLive"));
const getExperiment_1 = __importDefault(require("../experiments/getExperiment"));
exports.default = (experiments, config) => {
    const experimentsAlreadyActiveForCurrentUser = [];
    const experimentsGroupedByGoal = experiments.reduce((experimentsGrouped, currentExperiment) => {
        // Dont allow assignment of experiments that are invalid / expired / already assigned
        const isExperimentValid = getIsExperimentValid_1.default(currentExperiment, config);
        if (!isExperimentValid)
            return experimentsGrouped;
        const isExperimentLive = getIsExperimentLive_1.default(currentExperiment, config);
        if (!isExperimentLive)
            return experimentsGrouped;
        const isAlreadyAssignedToExperiment = getExperiment_1.default(currentExperiment.goal, currentExperiment.name) !== null;
        if (isAlreadyAssignedToExperiment) {
            experimentsAlreadyActiveForCurrentUser.push(currentExperiment);
            return experimentsGrouped;
        }
        // Add experiment as a candidate for selection under it's goal type
        if (!experimentsGrouped[currentExperiment.goal]) {
            experimentsGrouped[currentExperiment.goal] = [currentExperiment];
        }
        else {
            experimentsGrouped[currentExperiment.goal].push(currentExperiment);
        }
        return experimentsGrouped;
    }, {});
    return {
        availableExperimentsGroupedByGoal: experimentsGroupedByGoal,
        availableExperimentGoalKeys: Object.keys(experimentsGroupedByGoal),
        experimentsAlreadyActiveForCurrentUser,
    };
};
//# sourceMappingURL=getActiveExperiments.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/getActiveExperiments.js
// module id = uhHN
// module chunks = 55